export const MESSAGES: Messages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description: "Aliquota cadastrada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    WARNING: {
      variant: "information",
      description: "Aliquota adicionada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao criar aliquota.",
      duration: 5000,
      closeOnClick: true,
    },
  },
};
